var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('a',{staticClass:"meeting-join",class:_vm.isTeams ? 'meeting-join--teams' : 'meeting-join--meet',attrs:{"href":_vm.url,"target":"_blank","rel":"noopener"}},[_c('vs-icon',{attrs:{"icon":"videocam"}}),_vm._v(_vm._s(_vm.label)+"\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }